import { Avatar, Chip, Stack, SvgIcon, Typography } from "@mui/material";
import FrameHeader from "../../ui/containers/FrameHeader";
import EntryCount from "./EntryCount";
import { styled, Box } from "@mui/system";
import { ReactComponent as WarlordIcon } from "../../assets/icons/warlord.svg";
import useGameSettings from "../../hooks/use-game-settings";

const EntryAvatar = styled(Avatar)({
	width: "75px",
	height: "75px",
});

function EntryPanelHeader({ entry, activeProfileIndex = null, factionSlug, nodeType }) {
	const { name, slug, type, gameClass, cost, size, tagGroups, profiles } = entry;
	const height = entry.height || entry.profiles?.[activeProfileIndex]?.height;
	const { getEntrySettings, getFactionSettings } = useGameSettings();
	const icon = getEntrySettings(slug)?.icon ||
		getFactionSettings(factionSlug).defaultEntryIcon;
	const activeProfile = activeProfileIndex === null ? null : profiles[activeProfileIndex];
	const subtitle = activeProfile ? activeProfile.name : null;
	const statline = activeProfile?.statline || entry.statline;
	const statlineOrder = ["M", "V", "C", "A", "W", "R", "D", "E", "CR"];

	const chips = [];
	if (type) chips.push(type);
	if (gameClass) chips.push(gameClass);

	const groups = tagGroups || profiles?.[activeProfileIndex]?.tagGroups;
	if (groups) {
		const roles = groups.find(g => g.slug === "battlefield-roles");
		const names = roles?.tags?.map(r => r.name) || [];
		chips.push(...names);
	}

	return (
		<FrameHeader>
			<Stack direction="row" spacing={1}>
				<EntryAvatar variant="rounded" src={icon} />
				<Box flexGrow={1}>
					<Stack direction="row" spacing={0.5} alignItems="center">
						{entry.isWarlord && (
							<SvgIcon fontSize="small">
								<WarlordIcon />
							</SvgIcon>
						)}
						<Typography variant="h5" flexGrow={1}>
							{name}
						</Typography>
						{nodeType !== "officer" && (
							<Typography variant="h5" textAlign="right">
								{cost === 0 ? "Free" : cost}
							</Typography>
						)}
					</Stack>
					{subtitle && (
						<Typography variant="subtitle1" lineHeight={1}>
							{subtitle}
						</Typography>
					)}
					<Stack
						direction="row"
						spacing={1}
						mt={1}
						justifyContent="space-between"
					>
						<Stack direction="row" gap={0.5} flexWrap="wrap">
							{chips.map(c => <Chip key={c} label={c} size="small" />)}
						</Stack>
						{nodeType !== "officer" && <EntryCount count={size} />}
					</Stack>
				</Box>
			</Stack>
			{statline && (
				<Stack direction="row" mt={2}>
					{statlineOrder.map(
						(key) =>
							statline[key] !== undefined && (
								<Box key={key} textAlign="center" flex="1 1 0">
									<Typography
										variant="h5"
										lineHeight={1.6}
										borderBottom="1px solid white"
									>
										{key}
									</Typography>
									<Typography variant="h5" lineHeight={1.6}>
										{statline[key]}
									</Typography>
								</Box>
							)
					)}
					{height && (
						<Box textAlign="center" flex="1 1 0" ml={2}>
							<Typography
								variant="h5"
								lineHeight={1.6}
								borderBottom="1px solid transparent"
							>
								Size
							</Typography>
							<Typography variant="h5" lineHeight={1.6}>
								{height}
							</Typography>
						</Box>
					)}
				</Stack>
			)}
		</FrameHeader>
	);
}

export default EntryPanelHeader;
